import { apiAuth, apiResponseType } from "./index";

export interface LeadTrackingItem {
  id: number;
  uuid: string;
  client_name: string;
  seller_name: string;
  media_name: string;
  created_by_name: string;
  created_at: string;
  file?: string | null;
}

export interface LeadTrackingFilters {
  seller_id?: number;
  media_id?: number;
  created_by_id?: number;
  start_date?: string;
  end_date?: string;
  page?: number;
}

export const getLeadTracking = (filters: LeadTrackingFilters = {}): apiResponseType => {
  const params = new URLSearchParams();

  if (filters.page) params.append("page", filters.page.toString());
  if (filters.seller_id) params.append("seller_id", filters.seller_id.toString());
  if (filters.media_id) params.append("media_id", filters.media_id.toString());
  if (filters.created_by_id) params.append("created_by_id", filters.created_by_id.toString());
  if (filters.start_date) params.append("start_date", filters.start_date);
  if (filters.end_date) params.append("end_date", filters.end_date);

  return apiAuth.get(`leads/tracking?${params.toString()}`);
};

export const getLeadTrackingShow = (uuid: string): apiResponseType => {
  return apiAuth.get(`leads/tracking/${uuid}/show`);
};

export const getLeadTrackingMedias = (): apiResponseType => {
  return apiAuth.get("leads/tracking/medias");
};
